import React from 'react'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import Container from '../foundations/Container'
import Action from '../primitives/Action'
import styles from './RelatedServices.module.scss'

const SITE_ORIGIN = 'https://miamisoundrental.com'

const normalizeServiceUrl = value => {
  if (!value) return null

  try {
    const url = new URL(value, SITE_ORIGIN)
    const path = url.pathname.replace(/\/$/, '') || '/'

    return url.origin === SITE_ORIGIN ? `${path}${url.search}${url.hash}` : value
  } catch (error) {
    return value
  }
}

const serviceKey = value => {
  const normalized = normalizeServiceUrl(value)

  try {
    const url = new URL(normalized, SITE_ORIGIN)
    return `${url.origin}${url.pathname.replace(/\/$/, '') || '/'}${url.search}${url.hash}`
  } catch (error) {
    return normalized
  }
}

const RelatedServices = ({
  subCategory,
  eyebrow = 'Complete your setup',
  heading = 'Frequently rented together',
  description,
  headingId = 'related-audio-services',
  additionalServices = []
}) => {
  const services = [
    ...additionalServices,
    ...(subCategory?.similar_categories?.filter(service => service.h1) || [])
  ]
    .filter((service, index, array) => service?.url && (
      array.findIndex(candidate => serviceKey(candidate?.url) === serviceKey(service.url)) === index
    ))
    .map(service => ({ ...service, url: normalizeServiceUrl(service.url) }))
    .slice(0, 6)
  if (!services.length) return null

  return (
    <section className={styles.section} aria-labelledby={headingId}>
      <Container>
        <div className={styles.heading}>
          {eyebrow && <span>{eyebrow}</span>}
          <h2 id={headingId}>{heading}</h2>
          {description && <p>{description}</p>}
        </div>
        <div className={styles.grid}>
          {services.map(service => (
            <Action
              dataConversionChannel={service.conversionChannel}
              dataConversionKey={service.conversionKey}
              dataConversionLocation={service.conversionLocation || headingId}
              dataConversionSalesPath={service.conversionSalesPath}
              href={service.url}
              key={service.url || service.name}
              onClick={service.onClick}
              variant='plain'
              wrapContent={false}
              className={styles.card}
            >
              <div>
                <strong>{service.h1 || service.name}</strong>
                <p>{service.miniText || 'View equipment, availability, and rental options.'}</p>
              </div>
              <FiArrowRight aria-hidden='true' />
            </Action>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default RelatedServices
